export default "__VITE_ASSET__BpItpp52__"